import { cn } from "@/utils/cnHelper";
import * as React from "react";

interface ImageMarqueeProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  pauseOnHover?: boolean;
  direction?: "left" | "right";
  speed?: number;
}

export function ImageMarquee({
  children,
  pauseOnHover = false,
  direction = "left",
  speed = 30,
  className,
  ...props
}: ImageMarqueeProps) {
  return (
    <div className={cn("tw-z-10 tw-w-full tw-overflow-hidden tw-py-4 sm:tw-py-6", className)} {...props}>
      <div className="tw-relative tw-flex tw-overflow-hidden">
        <div
          className={cn(
            "tw-flex tw-w-max tw-animate-marquee",
            pauseOnHover && "hover:[animation-play-state:paused]",
            direction === "right" && "tw-animate-marqueeReverse"
          )}
          style={{ "--duration": `${speed}s` } as React.CSSProperties}
        >
          {children}
          {children}
        </div>
      </div>
    </div>
  );
}
